


























































































































































import JSEncrypt from "jsencrypt";
export default {
  name: "doctor-template",
  props: ["config"],
  data() {
    return {
      checked: false,
      openEye: false,
      clock: false,
      time: 60,
      formData: {
        phone: "",
        checkNum: "",
        password: ""
      },
      formTest: {
        phone: false,
        checkNum: false,
        password: false
      }
    };
  },
  computed: {
    next: function() {
      const flag =
        (this as any).checked &&
        Object.keys((this as any).formData).every(
          key => (this as any).formData[key]
        ) &&
        Object.keys((this as any).formTest).every(
          key => !(this as any).formTest[key]
        );
      return flag;
    }
  },
  watch: {
    config: {
      handler(newCul: any) {
        const instance = this as any;
        instance.checked = newCul.protocolStatus;
      },
      immediate: true
    }
  },
  mounted() {
    console.log((this as any).$attrs, "this.$attrs");
  },
  methods: {
    limit(key: string) {
      if (key === "phone" && (this as any).formData[key].length > 11) {
        (this as any).formData[key] = (this as any).formData[key].slice(0, 11);
      }
    },
    test(propName: string) {
      let testPorp = /^[1][0-9]{10}$/;
      if (propName === "phone") {
        testPorp = /^[1][0-9]{10}$/;
      } else if (propName === "password") {
        testPorp = /^[0-9A-Za-z]{6,16}$/;
      }
      if (
        !(this as any).formData[propName] ||
        !testPorp.test((this as any).formData[propName])
      ) {
        (this as any).formTest[propName] = true;
      } else {
        (this as any).formTest[propName] = false;
      }
    },
    clear(propName: string) {
      (this as any).formData[propName] = "";
    },
    sendSms() {
      const phoneReg = /^[1][0-9]{10}$/;
      if (
        !(this as any).formData.phone ||
        !phoneReg.test((this as any).formData["phone"])
      ) {
        (this as any).formTest.phone = true;
        return;
      }
      (this as any).clock = true;
      (this as any).time = 60;
      const inter = setInterval(() => {
        (this as any).time--;
        if ((this as any).time <= 0) {
          clearInterval(inter);
          (this as any).clock = false;
        }
      }, 1000);
      const config = (this as any).config;
      const params = {
        businessType: config.businessType,
        phone: (this as any).formData.phone,
        smsType: config.smsType,
        userType: config.userType
      };
      (this as any).$emit("send-sms", params);
    },
    encryptDeal(msg: string) {
      const publicKey =
        "MFwwDQYJKoZIhvcNAQEBBQADSwAwSAJBAKbpotLkdWJlxvWuydKwQkryMb3m2mZrj8tizRUbwBW9Bnyu0syIXz+IkxP6Z76b4cEO2NyEq5yPcJdaBKynSVcCAwEAAQ==";

      const encrypt = new JSEncrypt();
      encrypt.setPublicKey(publicKey);
      return encrypt.encrypt(msg);
    },
    nextFun() {
      if (!(this as any).next) return;
      const instance = this as any;
      const config = (this as any).config;
      const params = {
        account: (this as any).formData.phone,
        checkNum: (this as any).formData.checkNum,
        userType: config.userType,
        password: instance.encryptDeal((this as any).formData.password),
        source: "h5",
      };
      (this as any).$emit("register-handle", params);
    },
    goUrl(url: string) {
      window.location.href = url;
    }
  }
};
